"use strict";

var React = require("react");

var styletron = require("./index");

var _require = require("styletron-react"),
    Provider = _require.Provider; // eslint-disable-next-line react/prop-types


exports.wrapRootElement = function (_ref, options) {
  var element = _ref.element;
  return React.createElement(Provider, {
    value: styletron(options).instance
  }, element);
};